import { render, staticRenderFns } from "./AMPMComponent.vue?vue&type=template&id=1b051206"
import script from "./AMPMComponent.vue?vue&type=script&lang=js"
export * from "./AMPMComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports